<template>
  <div class="aqui-estamos contenido">
    <div class="container">
    <HelloWorld 
        msg="Aquí estamos de nuevo"
        idea="Renovados y preparados para ofrecerte una serie de productos especiales para este momento o para el futuro."
        :imagen="imagen"
     />
     <FotoTextoLanding id="COVID" class="mt-5" titulo="Para protegerte del COVID accesible y rápidamente:" texto="Con un seguro de gastos médicos y atención hospitalaria de COVID-19, con contratación en línea y a un precio totalmente a tu alcance.<br /><br />Un plan que incluye:<br /><br />
     <ul>
        <li>Estudios de laboratorio, gabinete e imagenología</li>
         <li>Equipo de hospital incluyendo respirador artificial</li>
         <li>Home Care (oxigenoterapia, enfermera y fisioterapia pulmonar)</li></ul>" linkURL="https://rmzasesores.com/aqui-estamos-preparados#COVID" video="WiPMsIqhSTg" pos="fotovideo"></FotoTextoLanding>
     <div class="grisSombra my-5 py-5">
         <FotoTextoLanding id="Reestructura" titulo="Para ayudarte a reestructurar tu seguro:" texto="Sabemos que estas preparado con una protección de gastos médicos mayores, pero que quizá por estos tiempos requieres realizar ajustes." linkURL="https://rmzasesores.com/aqui-estamos-preparados#Reestructura" :imagen="imagen3" pos="fotoizquierda"></FotoTextoLanding>
     </div>
     <div class="row justify-content-center px-5">
        <div class="col-md-6 my-5">
             <FotoTextoLanding id="Ampliaproteccion" titulo="Para que amplíes tu protección:" texto="Ahora que entiendes lo que significa tu casa, te ofrecemos planes para que la cuides como ella a ti:<br /><br />Protección para tu hogar a 3,6,y 12 meses sin intereses* pagando con AmEx, Santander, BBVA y Banamex" linkURL="https://rmzasesores.com/aqui-estamos-preparados#Ampliaproteccion" :imagen="imagen4" pos="fotoarriba"></FotoTextoLanding>
        </div>
        <div class="col-md-6 my-5">
             <FotoTextoLanding id="Auto" titulo="Para ofrecerte más opciones:" texto="Tu auto ahora está estacionado pero pronto regresará a la circulación, protégelo y ahorra en este momento:<br /><br />
            <ul>
            <li>Si contratas durante mayo y junio, recibes 14 meses a precio de 12.</li>
            <li>Descuento de un mes en el costo del seguro de tu auto.</li>
            <li>3, 6 y hasta 12 meses sin interés* pagando con AmEx, Santander, BBVA y Banamex.</li>
            <li>Beneficios adicionales sin costo: un 10% más al valor de tu vehículo y deducibles preferenciales.</li>
            <li>10% de descuento en la contratación de tu seguro de auto, pagando con tarjeta de crédito.</li>
        </ul>" linkURL="https://rmzasesores.com/aqui-estamos-preparados#Auto" :imagen="imagen5" pos="fotoarriba"></FotoTextoLanding>
        </div>
     </div>
  </div>
  <div class="fondoGris p-5">
     <div class="container">
         <FotoTextoLanding id="Beneficios" titulo="Para darte más beneficios" texto="Si algo ha quedado claro en este tiempo es que la reciprocidad, es una de las claves para continuar juntos por un mejor camino; aquí te ofrecemos algunos beneficios extras si tienes algún plan contratado con nosotros:<br /><br /><strong>*Aplican restricciones.</strong>" linkURL="https://rmzasesores.com/aqui-estamos-preparados#Beneficios" aviso="<ul><li class='mb-4'>En la contratación de tu seguro de gastos médicos mayores, tu seguro de auto te da un 10% de descuento.</li><li class='mb-4'>Si contratas con nosotros tu seguro de gastos médicos, recibe 10% de descuento y 6 meses sin intereses, en la contratación de tu seguro de auto.</li><li class='mb-4'>¿Ya pensaste en tu casa? Si contrataste tu seguro de gastos médicos o auto con nosotros, recibe un descuento de hasta el equivalente a un mes, más meses sin intereses en el seguro de tu casa, hablemos.</li></ul>" pos="conaviso"></FotoTextoLanding>
      </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-landingpage-campaign01-fase02-01aquiestamosdenuevo.jpg'
import FotoTextoLanding from '@/components/FotoTextoLanding.vue'
import Imagen2 from '@/assets/images/pageinteriors_individuos-y-familias-01autos.jpg'
import Imagen3 from '@/assets/images/landingpage_campaign01-fase02-01reestructurar.jpg'
import Imagen4 from '@/assets/images/landingpage_campaign01-fase02-02proteccionhogar.jpg'
import Imagen5 from '@/assets/images/landingpage_campaign01-fase02-03proteccionauto.jpg'
export default {
  name: 'Individuos-y-familias',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
          imagen5: Imagen5,
      }
  },
  components: {
    HelloWorld,
    FotoTextoLanding,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      },
      anchorHashCheck() {
          console.log(window.location.hash);
          if (window.location.hash) {
              console.log('ENTRO');
              setTimeout(function(){
                  document.getElementById(window.location.hash.replace('#', '')).scrollIntoView();
              }, 500);
          }
      },
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
      this.$store.commit('ocultaFooter');
      this.anchorHashCheck()
  }
}
</script>
<style scoped>
.fondoGris, .modificaTriangulo {
    background-color: #F2F2F2;
}
.fondoGris {
    background-image: url(../assets/images/background-textura-01masbeneficios.png);
    background-size: auto;
    background-position: left bottom;
    background-repeat: no-repeat;
}
.grisSombra {
    background: #d9f6ff;
    box-shadow: 10px 10px 0 #000;
    border: 3px solid #1900FF;
}
.contenido {
    min-height: 500px;
}
@media only screen and (max-width: 1199px){
}
</style>
<style>
.modificaTriangulo .triangulo {
    margin-top: 0 !important;
}
.grisSombra .btn-primary {
    background-color: #d9f6ff !important;
}
.fondoGris .btn-primary {
    background-color: #F2F2F2 !important;
}
</style>
